import { gql } from '@apollo/client';

export const EXPORT_FUNDER_SCHOOL_ATTENDANCE = gql`
  query ExportFunderSchoolAttendance($input: ExportArgs!) {
    exportFunderSchoolAttendance(input: $input) {
      id
      name
      class
      focusSubjects {
        id
        name
      }
      grades {
        id
        name
        value
      }
      programme {
        id
        name
      }
      serviceProviders {
        id
        name
      }
      subject {
        id
        name
        subjectGradeReference
      }
      schoolAttendanceData {
        id
        absentDays
        absenteeismRate
        actualAttendance
        attendanceRate
        circuit {
          id
          name
        }
        district {
          id
          name
        }
        emisNumber
        grade {
          id
          value
        }
        numberEnrolled
        possibleAttendance
        term
        year
        institution {
          id
          emisNumber
          name
        }
      }
    }
  }
`;
